// Información de build generada automáticamente
export const BUILD_DATE = '12-01-2026 19:01:29';
export const BUILD_HASH = 'x0t9wxfyll';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1768255289837;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '12-01-2026 19:01:29',
  buildHash: 'x0t9wxfyll',
  appVersion: '0.0.0',
  timestamp: 1768255289837
});
